
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/[id]",
      function () {
        return require("private-next-pages/r/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r/[id]"])
      });
    }
  